module.exports = __webpack_public_path__ + "img/user-profile.4ad76dd8.png";